export enum PaymentProfileStatus {
  Missing = 'Missing',
  New = 'New',
  Submitted_to_PC = 'Submitted to PC',
  Completed = 'Completed',
  Expired = 'Expired'
}

export enum PaymentProfileDashboardStatus {
  Missing = 'Missing',
  Requested = 'Requested',
  Pending_Completion = 'Pending Completion',
  Completed = 'Completed',
  Expired = 'Expired'
}

export enum PmoNextStepStatus {
  Validate_Opportunity_Size = 'Validate opportunity size'
}

export enum OpsStatus {
  Validate_MSX_ID = 'Validate MSX ID'
}

export enum DocumentsType {
  POEInvoice = 1,
  CustomerAcknowledgement = 2,
  POEDocument = 3,
  CustomerPOESurvey = 4,
  AdditionalDocument = 5,
  PartnerPOESurvey = 6,
  PrivatePartnerAccessList = 7,
  PrivateCustomerAccessList = 8,
  RequestForProposalAwardLetter = 9,
  RequestForProposalDescription = 10,
  DealAssociationTemplate = 11,
  SOW = 13
}

export enum PaymentBatchStatus {
  Open = 1,
  InProgress = 2,
  Paid = 3,
  Cancelled = 4
}

export enum ProgramTypes {
  Accelerator = 1,
  MSSP = 2,
  Operator = 3,
  Events = 4,
  MSAIP = 5,
  MRPP = 6
}

export enum ProgramTypesGUID {
  MCAP = '4E74B7AE-528C-49CD-A791-B96D31AB2F8F',
  MSSP = '4AD89CA0-FECF-41B7-95C8-213617F435FE',
  Operator = '9DD142DC-8850-4367-81FE-1C9528C547C9',
  Events = 'D972DA85-0565-4971-B031-FC44878C6EA9',
  MSAIP = '9D1E066E-2EBE-4677-AFCC-CD41F2C57E28',
  MRPP = 'C5D3A897-C737-4EEC-BFC7-D9FF1FB7F315'
}

export enum EventCategory {
  ModernWork = 1,
  MRPP = 2
}

export enum TabName {
  CustomerAckApproval = 1,
  FindingDocReview = 2,
  InvoiceDocReview = 3,
  CustomerSurveyReview = 4,
  AllActivity = 5,
  RfpAwardLetter = 6,
  RfpDescription = 7
}

export enum EventCustomerValidationType {
  TenantID = 1,
  TPID,
  DB,
  WebURL,
  SubscriptionId
}

export enum EventCustomerValidationStatus {
  Pending = 1,
  Approved,
  Rejected
}

export enum EventCustomerValidationStatusNames {
  Pending = 'Pending',
  Approved = 'Approved',
  Rejected = 'Rejected'
}

export enum EventSearchType {
  AllEvents,
  InvoiceDocument,
  CustomerSurveyReview,
  RollCallReview,
  InvoiceDocReview,
  SKUPurchaseTrialActivationReview,
  DealAssociationCPORTemplate,
  DealAssociationPOETemplate,
  DealAssociationRFPTemplate,
  MADPOE,
  PublicSectorPOE,
  MicrosoftInvoiceTemplate,
  POETemplate,
  SOWDocument,
  CustomerValidationReview
}

export enum EventStatusNames {
  Ineligible = 'Ineligible',
  Approved = 'Approved',
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Paid = 'Paid',
  Expired = 'Expired'
}

export enum EventStatus {
  Ineligible = 2,
  Approved = 4,
  Cancelled = 5,
  Completed = 6,
  Paid = 7,
  Expired = 8
}

export enum EventDocumentType {
  POEInvoice = 'Invoice',
  FindingsDocument = 'Findings document',
  POETemplate = 'Roll Call Template',
  POESKUTrial = 'POE SKU / Trial',
  CustomerAwardLetter = 'Customer Award Letter',
  CustomerPartnerOfRecord = 'Customer Partner Of Record',
  DealAssociationTemplate = 'Deal Association Template',
  DealAssociationTemplateRFP = 'Deal Association Template RFP',
  MADPOE = 'MAD POE',
  PublicSectorPOE = 'Public Sector POE',
  MicrosoftInvoiceTemplate = 'POE Invoice',
  FindingsTemplate = 'Findings Template',
  SOW = 'Statement of Work'
}

export enum EventSurveyStatus {
  NotStarted = 1,
  Started,
  InReview,
  Rejected,
  Completed,
  Missing
}

export enum CustomerAcknowledgementDocumentStatus {
  Approved = 'Approved',
  InReview = 'InReview',
  Missing = 'Missing',
  Rejected = 'Rejected'
}

export enum PaymentScheduleTabName {
  Milestone1 = 1,
  Milestone2
}

export enum Milestone2PaymentBatchStatus {
  Open = 1,
  InProgress = 2,
  Paid = 3,
  Cancelled = 4
}

export enum SpecialInvestmentPaymentScheduleTab {
  Milestone1 = 'Milestone 1 Payment Schedule',
  Milestone2 = 'Milestone 2 Payment Schedule'
}

export enum EventsPaymentScheduleTab {
  Milestone1 = 'Milestone 1 Payment Schedule',
  Milestone2 = 'Milestone 2 Payment Schedule'
}

export enum EnagagementTypes {
  GSI = 64
}

export enum AdvisorIncentiveWorkshopName {
  Frontline_Worker_Deal_Association = 'Frontline Worker - Deal Association',
  Microsoft_Viva_Deal_Association = 'Microsoft Viva - Deal Association',
  Frontline_Worker_MCI = 'Frontline Worker - Workshop',
  Microsoft_Viva_MCI = 'Microsoft Viva - Workshop'
}

export enum MSSPOperatorWorkshop {
  MSSP_SecurityRFP = 'Security Request for Proposal',
  Operator_SecurityRFP = 'Operator Request for Proposal',
  DealAssociation = 'Deal Association'
}

export enum PreventMilestone2DesignationEdit {
  MSSP_DAT = 'Defend Against Threats with SIEM Plus XDR Workshop',
  TPE = 'Threat Protection Engagement'
}

export enum Milestone2Designations {
  SecurityACR = 1,
  M365SecuritySales = 2,
  SecurityACRandM365SecuritySales = 3
}

export enum EventWorkshop {
  M365_Do_More_With_Less = 'Microsoft 365: Do More With Less',
  M365_for_business = 'M365 for business',
  Microsoft_Teams_Essentials = 'Microsoft Teams Essentials',
  Microsoft_Windows_365 = 'Microsoft Windows 365'
}

export enum StatusCodes {
  Waiting_For_Milestone2_Eligibility = 'Waiting for Milestone 2 eligibility',
  Qualified_For_Milestone2 = 'Qualified for Milestone 2',
  POE_Complete_For_Milestone1 = 'POE complete for Milestone 1',
  //For old statuses
  Ready_For_Payment = 'Ready for payment',
  Process_For_Payment = 'Process for Payment',
  Submit_In_PC = 'Submit in PC'
}

export enum PaymentStatus {
  Readyforpayment = 1,
  Paid,
  Submittedforpayment,
  Immature,
  TierNotMet,
  Expired
}

export enum MaturityStatus {
  Mature = 'Mature',
  Immature = 'Immature',
  TierDowngrade = 'Tier Downgrade',
  Ineligible = 'Ineligible'
}

export enum EventDocumentTypeIds {
  POEInvoice = 1,
  RollCall,
  POESKUTrial,
  EventPartnerAccessList,
  CustomerAwardLetter,
  CustomerPartnerOfRecord = 6,
  DealAssociationTemplate,
  DealAssociationTemplateRFP,
  PublicSectorPOE,
  MicrosoftInvoiceTemplate,
  FindingsTemplate = 12,
  SOW = 13
}

export enum EventType {
  M365ForBusiness = 1,
  MicrosoftTeamsEssentials,
  MicrosoftWindows365,
  Microsoft365DoMoreWithLess,
  DoMoreWithBusinessPremium,
  DoMoreWithE3E5,
  DealAssociation,
  DealAssociationRequestforProposal,
  DoMorewithME3DealAssociation,
  TeamsRoomsPilot,
  TeamsRoomsOneToMany
}

export enum EventDocumentStatus {
  NotStarted = 'Not Started',
  Started = 'Started',
  InReview = 'In Review',
  Rejected = 'Rejected',
  Completed = 'Completed',
  Missing = 'Missing'
}

export enum EventPOEStatus {
  NotStarted = 1,
  Started,
  InReview,
  Rejected,
  Completed,
  Missing
}

export enum PartnerAccessRequestType {
  DirectMember = 'Direct Member',
  PartnerOne = 'PartnerOne Member',
  None = 'None'
}
export enum PartnerAccessActions {
  Review = 'Review',
  Approve = 'Approve',
  Reject = 'Reject'
}

export enum SurveyStatus {
  InReview = 'In Review',
  Missing = 'Missing',
  Submitted = 'Submitted',
  Rejected = 'Rejected',
  Completed = 'Completed'
}
